import { NgClass } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ToastService } from "~app/common/components/toast/toast.service";
import { SystemadministrationService } from "../../systemadministration.service";
import { VerksamhetsomradeService } from "./verksamhetsomrade.service";

@Component({
    selector: "rask-sysadm-verksamhetsomraden",
    templateUrl: "./sysadm-verksamhetsomraden.component.html",
    styleUrls: ["./sysadm-verksamhetsomraden.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        ButtonComponent,
        NgClass
    ]
})
export class SysadmVerksamhetsomradenComponent {
    infoClass: string;
    message: string;

    private readonly busyService = inject(BusyService);
    private readonly systemadministrationService = inject(SystemadministrationService);
    private readonly toastService = inject(ToastService);
    private readonly verksamhetsomradeService = inject(VerksamhetsomradeService);

    migrateJokkmokkToBoden() {
        this.busyService.addWork(
            this.systemadministrationService.scheduleCommand({ $type: "MigrateJokkmokkToBodenCommand" }, 1))
            .subscribe((_: any) => {
                this.toastService.add("Migrering upplagd på jobbkö. Monitera jobbkö till det behandlats.");
            });
    }

    uploadFile(files: any, dryRun: boolean) {
        this.setStatus("", "");
        const upload = this.verksamhetsomradeService.uploadVerksamhetsomrade(files[0], dryRun);
        this.busyService.addWork(upload).subscribe(
            {
                next: (result: any) => {
                    if (result.status) {

                        this.setStatus(result.message, "alert-success");
                    } else {

                        this.setStatus("Uppladdningsfel", "alert-danger");
                    }
                },
                error: () => {
                    this.setStatus("Uppladdningsfel", "alert-danger");
                }
            }
        );
    }

    private setStatus(message: string, className: string) {
        this.message = message;
        this.infoClass = className;
    }
}
